export default {
    methods: {
        showError(error, msg) {
            let title = msg || 'Something went wrong';
            let errorMsg = error.message;

            if (error.response && error.response.data && error.response.data.message) {
                errorMsg = error.response.data.message;
            }

            this.$bvToast.toast(errorMsg, {
                title: `${title}`,
                toaster: 'b-toaster-top-center',
                solid: true,
                variant: 'danger',
                autoHideDelay: 3000,
            });
        },
        showToast(title, msg) {
            this.$bvToast.toast(msg, {
                title: `${title}`,
                toaster: 'b-toaster-top-center',
                solid: true,
                variant: 'secondary',
            });
        },
        formatPrice(price) {
            if (!price) {
              return 0;
            }
    
            return price.toLocaleString(undefined, { minimumFractionDigits: 2 });
        },
    }
}